import authHeader from 'srcReact/helpers/auth-header'
import axios from 'axios'
import { doRequestAxios } from 'srcReact/helpers/apiHelper'
import { appConstantSettings } from 'srcReact/appConstantSettings'

export const organizationService = {
  getById,
  getByUser,
  getByIdAndUser,
  create,
  remove,
  switchOrganization,
  getMemberDirectory,
  getNotificationList,
  markNotificationAsRead,
  getHeaderInfo,
  getOrganizationInfo,
  editOrganizationInfo,
  getOrganizationWorkplaceList,
  getLeadershipTeam,
  getOrganizationMembers,
  getOrganizationSubscription,
  getPaymentInformationUrl,
  getInvoices,
  downloadInvoice,
  reinstateUser,
  deleteAccount,
  getOrgFiles,
  addOrgFile,
  updateOrgFile,
  deleteOrgFile,
  updateOrgRole,
  notificationTemporaryMute,
  notificationTemporaryUnmute
}

let cancel

function switchOrganization(id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader()
  }
  return doRequestAxios(`/organization/${id}/switch`, requestOptions)
}

function getMemberDirectory(id, workplaceId, searchByMember, orderBy, quantity, nextOffset) {
  if (cancel) {
    cancel()
  }
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    cancelToken: new axios.CancelToken((c) => (cancel = c))
  }

  let apiUrl = `/organization/member/?organization_id=${id}`
  if (workplaceId && workplaceId > 0) {
    apiUrl += `&workplace_id=${workplaceId}`
  }
  if (orderBy && orderBy.length > 0) {
    apiUrl += `&orderby=${orderBy}`
  }
  if (searchByMember && searchByMember.length > 1) {
    apiUrl += `&search=${searchByMember}`
  }
  if (quantity && quantity > 0) {
    apiUrl += `&quantity=${quantity}`
  }
  if (nextOffset) {
    apiUrl += `&offset=${nextOffset}`
  }
  return doRequestAxios(apiUrl, requestOptions)
}

function getById(id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return doRequestAxios(`/organization/${id}?scope=organization`, requestOptions)
}

function getByIdAndUser(id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return doRequestAxios(
    `/organization/search?scope=user&organization_id=${id}&filters=organizations-my_access,organizations-basicsettings,workplaces-my_rights`,
    requestOptions
  )
}

function getByUser(qty, fromRegistration = 0, orgId, origin) {
  let orgIdParams = ''
  let originParam = ''

  const quantity = qty ? `&quantity=${qty}` : ''
  const comingFromRegistration = fromRegistration == 1 ? `&from_registration=${fromRegistration}` : ''
  if (origin && origin.length > 0) {
    originParam = `&orig=${origin}`
  }
  if (orgId && orgId > 0) {
    orgIdParams = `&organization_id=${orgId}`
    //  params.organization_id = orgId
  }
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
    //params: params
  }
  return doRequestAxios(
    `/organization/search?scope=user${quantity}${comingFromRegistration}${orgIdParams}${originParam}&filters=organizations-basicsettings,organizations-my_access,workplaces-my_rights`,
    requestOptions
  )
}

function create(name, pictureId, color) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(1, ''),
    params: { metadata: JSON.stringify({ name, color, id_wp_sync_files_original: pictureId }) }
  }

  return doRequestAxios(`/organization/`, requestOptions)
}

function remove(id) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  }
  return doRequestAxios(`/organization/${id}`, requestOptions)
}

function getNotificationList(organizationId, isRead, offset, quantity) {
  let params = `?id_organization=${organizationId}`
  params += isRead && (isRead === 0 || isRead === 1) ? `&is_read=${isRead}` : ''
  params += offset ? `&notification_offset=${offset}` : ''
  params += quantity ? `&notification_quantity=${quantity}` : ''
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return doRequestAxios(`/v2/notifications/get-all-notifications${params}`, requestOptions)
}

function markNotificationAsRead(organizationId, notificationId) {
  let params = ''
  if (organizationId > 0) {
    params = `?id_organization=${organizationId}`
  } else if (notificationId > 0) {
    params = `?id_notification=${notificationId}`
  }
  const requestOptions = {
    method: 'PUT',
    headers: authHeader()
  }
  return doRequestAxios(`/v2/notifications/set-as-read${params}`, requestOptions)
}

function getHeaderInfo(organizationId, scope = '', popup = '', fromChargebee = 0, newsFeedId) {
  const params = { from_chargebee: fromChargebee }
  if (scope) {
    params.scope = scope
  }
  if (popup) {
    params.popup = popup
  }
  if (newsFeedId > -1) {
    params.newsfeed_id = newsFeedId
  }
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: params
  }
  return doRequestAxios(
    `/v2/user/header/get?organization_id=${organizationId}`,
    requestOptions,
    appConstantSettings.RETRY_COUNT,
    '',
    false
  )
}

function getOrganizationInfo(organization_id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: { organization_id }
  }
  return doRequestAxios(`/v2/organization/get-settings`, requestOptions)
}

function editOrganizationInfo(organization_id, name, color, accronym, google_translation_key, picture_id) {
  if (cancel !== undefined) {
    cancel()
  }
  const params = {
    organization_id,
    name,
    color,
    accronym,
    google_translation_key,
    id_wp_sync_files_original: picture_id?.toString()
  }

  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: params,
    cancelToken: new axios.CancelToken((c) => (cancel = c))
  }
  return doRequestAxios(`/v2/organization/edit-settings`, requestOptions)
}

function getOrganizationWorkplaceList(organization_id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: { organization_id }
  }
  return doRequestAxios(`/v2/organization/workplace-list`, requestOptions)
}

function getLeadershipTeam(organization_id, orderby) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: { organization_id, orderby }
  }
  return doRequestAxios(`/v2/organization/leadership-list`, requestOptions)
}

function getOrganizationMembers(organization_id, search, orderby, deactivated, requestToDelete, offset, quantity) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: { organization_id, search, orderby, offset, quantity, deactivated, request_to_delete: requestToDelete }
  }
  return doRequestAxios(`/v2/organization/members`, requestOptions)
}

function getOrganizationSubscription(organization_id, from_chargebee) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: { organization_id, from_chargebee }
  }
  return doRequestAxios(`/subscription`, requestOptions)
}

function getPaymentInformationUrl(organization_id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: { organization_id }
  }
  return doRequestAxios(`/subscription-payment-hosted-url`, requestOptions)
}

function getInvoices(organization_id, start_date, end_date) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: { organization_id, start_date, end_date }
  }
  return doRequestAxios(`/v2/organization/subscription/invoices`, requestOptions)
}

function downloadInvoice(organization_id, invoice_id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: { organization_id, invoice_id }
  }
  return doRequestAxios(`/v2/organization/subscription/downloadInvoice`, requestOptions)
}

function reinstateUser(orgId, userId) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: {
      id_organization: orgId,
      id_user: userId
    }
  }
  return doRequestAxios(`/v2/user/reinstate`, requestOptions)
}

function deleteAccount(orgId, userId, groupTransferData) {
  const params = {
    id_organization: orgId,
    id_user: userId
  }
  if (groupTransferData) {
    params.group_transfer_data = groupTransferData
  }
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: params
  }
  return doRequestAxios(`/v2/user/remove`, requestOptions)
}

function getOrgFiles(orgId, offset, quantity) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: { offset, quantity }
  }
  return doRequestAxios(`/v2/organization/get-files?organization_id=${orgId}`, requestOptions)
}

function addOrgFile(orgId, fileId, fileUrl) {
  let params = {}
  if (fileId) {
    params.file_id = fileId
  }
  if (fileUrl) {
    params.file_url = fileUrl
  }
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    params: params
  }
  return doRequestAxios(`/v2/organization/add-file?organization_id=${orgId}`, requestOptions)
}

function updateOrgFile(orgId, id, newFileId, newFileUrl) {
  let params = {}
  if (newFileId) {
    params.new_file_id = newFileId
  }
  if (newFileUrl) {
    params.new_file_url = newFileUrl
  }
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: params
  }
  return doRequestAxios(`/v2/organization/update-file?organization_id=${orgId}&id=${id}`, requestOptions)
}

function deleteOrgFile(orgId, id) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader()
  }
  return doRequestAxios(`/v2/organization/delete-file?organization_id=${orgId}&id=${id}`, requestOptions)
}

function updateOrgRole(orgId, userId, role, action) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: {
      organization_id: orgId,
      user_id: userId,
      role,
      action
    }
  }
  return doRequestAxios(`/v2/organization/update-role`, requestOptions)
}

function notificationTemporaryMute(minutes) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: { minutes }
  }
  return doRequestAxios(`/v2/user/settings/notification/temporary-mute`, requestOptions)
}

function notificationTemporaryUnmute() {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader()
  }
  return doRequestAxios(`/v2/user/settings/notification/temporary-unmute`, requestOptions)
}
